import { render, staticRenderFns } from "./job-ad-banner.vue?vue&type=template&id=94b736bc"
import script from "./job-ad-banner.vue?vue&type=script&lang=js"
export * from "./job-ad-banner.vue?vue&type=script&lang=js"
import style0 from "./job-ad-banner.vue?vue&type=style&index=0&id=94b736bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports